import { PropsWithClassName } from '@Framework/ui';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithClassName;

const AnimatedDots: React.FC<Props> = (props: PropsWithChildren<Props>): React.ReactElement => {
  return (
    <>
      <div className={['ods-dot', props.className].join(' ')} data-testid={'animated-dots-root'} />
      <style>
        {`
        .ods-dot {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: ${CORPORATE_COLORS.RED};
  color: ${CORPORATE_COLORS.RED};
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: .5s;
}

.ods-dot::before, .ods-dot::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

.ods-dot::before {
  left: -15px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: ${CORPORATE_COLORS.RED};
  color: ${CORPORATE_COLORS.RED};
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.ods-dot::after {
  left: 15px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: ${CORPORATE_COLORS.RED};
  color: ${CORPORATE_COLORS.RED};
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: ${CORPORATE_COLORS.RED};
  }
  50%,
  100% {
    background-color: #d3d3d3;
  }
}


        `}
      </style>
    </>
  );
};

export { AnimatedDots };
